import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import classNames from 'classnames';
import Checkbox from '../checkbox';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var _a = getCompProps('Card', userDefaultProps, props),
    tags = _a.tags,
    style = _a.style,
    title = _a.title,
    avatar = _a.avatar,
    actions = _a.actions,
    extra = _a.extra,
    children = _a.children,
    className = _a.className,
    hoverable = _a.hoverable,
    headStyle = _a.headStyle,
    bodyStyle = _a.bodyStyle,
    selectable = _a.selectable,
    checkboxProps = _a.checkboxProps,
    customPrefixcls = _a.prefixCls,
    others = __rest(_a, ["tags", "style", "title", "avatar", "actions", "extra", "children", "className", "hoverable", "headStyle", "bodyStyle", "selectable", "checkboxProps", "prefixCls"]);
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'card', customPrefixcls);
  var cardClassName = classNames(prefixCls, {
    hoverable: hoverable
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cardClassName,
    style: style
  }, others), title && !avatar && /*#__PURE__*/React.createElement("header", {
    className: "".concat(prefixCls, "-header"),
    style: headStyle
  }, title), avatar && /*#__PURE__*/React.createElement("header", {
    className: "".concat(prefixCls, "-avatar")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-avatar-img"), {
      circle: !avatar.square
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: avatar.src
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "".concat(prefixCls, "-avatar-title")
  }, avatar.title), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-avatar-desc")
  }, avatar.description))), selectable && /*#__PURE__*/React.createElement(Checkbox, _extends({}, checkboxProps)), tags && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-tags")
  }, tags), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, children), actions && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-actions")
  }, actions), extra && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra));
});
Card.displayName = 'Card';
export default Card;